import React, { useState, useEffect, useContext } from "react";
import salesRepData from "../data/salesRepData.json";
import QueryStringContext from "./QueryStringContext";
import SalesRepInfo from "./SalesRepInfo"; // Import the new SalesRepInfo component
import '../App.css';

const DemoForm = () => {
  const [submitted, setSubmitted] = useState(false);
  const [confirmationVisible, setConfirmationVisible] = useState(false);
  const { agent, f } = useContext(QueryStringContext);
  const [salesRep, setSalesRep] = useState(null);

  const handleFormSubmit = () => {
    setSubmitted(true);
  };

  const handleIframeLoad = () => {
    if (submitted) {
      setConfirmationVisible(true);
    }
  };

  useEffect(() => {
    const selectedSalesRep = salesRepData.find(
      (rep) => rep.id === parseInt(agent)
    );
    setSalesRep(selectedSalesRep);
  }, [agent]);

  return (
    <div className="center" style={{padding:'0rem', backgroundColor:'white', height:'100%'}}>
      <div className='center_8-10'style={{ padding :'0rem'}}>
      <div className='title_primary' style={{fontSize:'4vw', marginBottom:'2rem', marginLeft:'10%', marginRight:'10%', marginTop:'5%', textAlign:'center'}}>I'd love connect with you {f}!
      </div>
      </div>

      <div className='center_8-10'style={{ padding :'0rem'}}>
        {confirmationVisible ? (
          <p>Submission confirmed!</p>
        ) : (
          <>
            <iframe 
              title="hiddenConfirm"
              name="hiddenConfirm" 
              id="hiddenConfirm" 
              style={{ display: 'none' }} 
              onLoad={handleIframeLoad}
            ></iframe>

            <form 
              action="https://docs.google.com/forms/d/e/1FAIpQLScLXUCWkgn2KpzLItB7D6wqTm60RQbW7gECLxn1unPeoq7y-A/formResponse" 
              method="post" 
              target="hiddenConfirm" 
              onSubmit={handleFormSubmit}
            >


              <div className='contact-form-label' style={{ display: 'none' }}>
                <label htmlFor="email" className='inputPrompt'>Recruiting Agent Email: </label>
                <div>
                <input
                  type="hidden"
                  name="entry.1746162742"
                  className="form-input"
                  value={salesRep?.email || ''}
                />
                </div>
              </div>


              <div className='contact-form-label'>
                <label htmlFor="firstName" className='inputPrompt'>First Name: </label>
                <div>
                <input

                  type="text"
                  name="entry.1963368317"
                  className="form-input"
                />
                </div>
                
              </div>

              <div className='contact-form-label'>
                <label htmlFor="lastName" className='inputPrompt'>Last Name: </label>
                <div>
                <input
                  type="text"
                  name="entry.1791847106"
                  className="form-input"
                />
                </div>
              </div>

              <div className='contact-form-label'>
                <label htmlFor="email" className='inputPrompt'>Email: </label>
                <div>
                <input
                  type="email"
                  name="entry.2071862155"
                  className="form-input"
                />
                </div>
              </div>


              <div className='contact-form-label'>
                <label htmlFor="phone" className='inputPrompt'>Phone: </label>
                <div>
                <input
                  type="tel"
                  name="entry.861690353"
                  className="form-input"
                />
                </div>
              </div>





              <div className='contact-form-label'>
                  <label htmlFor="state" className="inputPrompt">
                    State:
                  </label>
                  <div>
                    <select
                      name="entry.550547014"
                      className="form-input"

                    >
                      <option value="">Select State</option>
                      <option value="AL">Alabama</option>
                      <option value="AK">Alaska</option>
                      <option value="AZ">Arizona</option>
                      <option value="AR">Arkansas</option>
                      <option value="CA">California</option>
                      <option value="CO">Colorado</option>
                      <option value="CT">Connecticut</option>
                      <option value="DE">Delaware</option>
                      <option value="FL">Florida</option>
                      <option value="GA">Georgia</option>
                      <option value="HI">Hawaii</option>
                      <option value="ID">Idaho</option>
                      <option value="IL">Illinois</option>
                      <option value="IN">Indiana</option>
                      <option value="IA">Iowa</option>
                      <option value="KS">Kansas</option>
                      <option value="KY">Kentucky</option>
                      <option value="LA">Louisiana</option>
                      <option value="ME">Maine</option>
                      <option value="MD">Maryland</option>
                      <option value="MA">Massachusetts</option>
                      <option value="MI">Michigan</option>
                      <option value="MN">Minnesota</option>
                      <option value="MS">Mississippi</option>
                      <option value="MO">Missouri</option>
                      <option value="MT">Montana</option>
                      <option value="NE">Nebraska</option>
                      <option value="NV">Nevada</option>
                      <option value="NH">New Hampshire</option>
                      <option value="NJ">New Jersey</option>
                      <option value="NM">New Mexico</option>
                      <option value="NY">New York</option>
                      <option value="NC">North Carolina</option>
                      <option value="ND">North Dakota</option>
                      <option value="OH">Ohio</option>
                      <option value="OK">Oklahoma</option>
                      <option value="OR">Oregon</option>
                      <option value="PA">Pennsylvania</option>
                      <option value="RI">Rhode Island</option>
                      <option value="SC">South Carolina</option>
                      <option value="SD">South Dakota</option>
                      <option value="TN">Tennessee</option>
                      <option value="TX">Texas</option>
                      <option value="UT">Utah</option>
                      <option value="VT">Vermont</option>
                      <option value="VA">Virginia</option>
                      <option value="WA">Washington</option>
                      <option value="WV">West Virginia</option>
                      <option value="WI">Wisconsin</option>
                      <option value="WY">Wyoming</option>

                    </select>
                  </div>
                </div>





              <div className='contact-form-label'>
                <label htmlFor="message" className='inputPrompt'>Message:</label>
                <div>
                <textarea
                  name="entry.2032488788"
                  className="form-textarea"
                  rows="1" /* start with 1 row and adjust as needed */
                ></textarea>
                </div>
                </div>

                <button type="submit" className="dnr_button">Submit</button>
            </form>
          </>
        )}
      </div>
      <div className='center' style={{maxWidth:'100%', padding:'0rem',}}>
    <SalesRepInfo salesRep={salesRep} />
    </div>
      </div>
  );
}

export default DemoForm;
